import { en } from './en.js';
import { hu } from './hu.js';
const i18config = {
  en: { translation: en },
  hu: { translation: hu }
};
export { i18config, en, hu }